export default {
  saving: 'Guardando...',
  savedChanges: 'Cambios guardados',
  error: 'Error'
}

export const en = {
  saving: 'Saving...',
  savedChanges: 'Changes saved',
  error: 'Error'
}

export const ca = {
  saving: 'Desant...',
  savedChanges: 'Canvis desats',
  error: 'Error'
}
